<template lang="pug">
EditDealTab(id="products")
  EditDealTabSection(:full-width="true")
    template(v-slot:header)
      h2 Products & Extras
    template(v-slot:body)
      DealProductsTable(
        :dealProducts="deal.Products"
        @removeProduct="removeProduct"
        @dealProductPriceOffsetInput="handleDealProductPriceOffsetInput"
        :pending="pending"
        )
      .validation-message(v-show="triedSavingProductsWithErrors")
        span {{ errorDealProductMessage }}
      AddProduct(
        :deal="deal"
        :products="products"
        :pending="pending"
        )
</template>

<script>
import EditDealTab from '@/vue/inventory/deals/edit/EditDealTab.vue'
import EditDealTabSection from '@/vue/inventory/deals/edit/EditDealTabSection.vue'
import DealProductsTable from '@/vue/components/DealProductsTable/DealProductsTable.vue'
import AddProduct from './AddProduct.vue'
import { sortBy, prop } from 'ramda'

export default {
  name: 'ProductsAndExtrasTab',
  components: {
    EditDealTab,
    EditDealTabSection,
    DealProductsTable,
    AddProduct,
  },
  inject: ['validations'],
  props: {
    deal: { type: Object, required: true },
    products: { type: Array, required: true },
    pending: Boolean,
  },
  data() {
    return {
      showAddProductModal: false,
      addProductPending: false,
      errorDealProductMessage: '',
    }
  },
  computed: {
    triedSavingProductsWithErrors() {
      this.errorDealProductMessage = this.triedSavingWithoutProducts
        ? 'Deal must contain at least one product'
        : this.triedSavingWithoutBaseProduct
        ? 'Deal must contain at least one base product'
        : ''
      return this.triedSavingWithoutProducts || this.triedSavingWithoutBaseProduct
    },
    triedSavingWithoutProducts() {
      return (
        this.validations?.$dirty &&
        this.validations.deal.Products.$invalid &&
        this.isEmptyDealProductsList
      )
    },
    triedSavingWithoutBaseProduct() {
      return (
        !this.triedSavingWithoutProducts && !this.validations.deal?.Products.validateBaseProduct
      )
    },
    isEmptyDealProductsList() {
      return !this.validations.deal?.Products.minLength || !this.validations.deal?.Products.required
    },
  },
  methods: {
    removeProduct(productIndex) {
      const isMatch = dpIndex => dpIndex === productIndex
      this.deal.Products = this.deal.Products.filter((_dp, dpIndex) => !isMatch(dpIndex))
      // todo: reorder
    },
    sortDealProducts() {
      const dealProductsSorter = sortBy(prop('ProgramOrder'))
      this.deal.Products = this.deal.Products ? dealProductsSorter(this.deal.Products) : []
    },
    handleDealProductPriceOffsetInput({ dealProductIndex, priceOffset }) {
      const dealProduct = this.deal.Products.find((_p, i) => i === dealProductIndex)
      dealProduct.PriceOffset = priceOffset
    },
  },
  beforeMount() {
    this.sortDealProducts() // sort products before pass as prop
  },
}
</script>
